import React from 'react';
import UIStrings from '@/Utils/UIStrings';

interface DialogCardInterviewHeaderProps {
    name: string;
}

function DialogCardInterviewHeader({ name }: DialogCardInterviewHeaderProps): React.JSX.Element {
    return (
        <div className="text-foreground text-xl font-bold">
            {`${UIStrings.Invite} ${name} ${UIStrings.ForAnInterview}`}
        </div>
    );
}

export default DialogCardInterviewHeader;
